import ProjectAcceptanceChart from './ProjectAcceptanceChart';

export default ProjectAcceptanceChart;
